import script from "./vmsChangeMyRole.vue?vue&type=script&lang=js"
export * from "./vmsChangeMyRole.vue?vue&type=script&lang=js"

import "./vmsChangeMyRole.vue?vue&type=style&index=0&id=f43f167a&lang=css"
import "./vmsChangeMyRole.vue?vue&type=style&index=1&id=f43f167a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f43f167a"]])

export default __exports__